module.exports = __webpack_public_path__ + "static/img/active_hb3.754d1513.png";